export default function Footer() {
  return (
    <footer className="bg-background-200 py-12">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="grid grid-cols-1 gap-8 md:grid-cols-4">
          <div className="md:col-span-1">
            <div className="flex items-center gap-2">
              <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-primary-500 text-lg text-background-50">
                <i className="ri-book-open-line"></i>
              </span>
              <span className="font-heading text-2xl text-foreground-950">
                静漫天堂
              </span>
            </div>
            <p className="mt-4 text-sm leading-relaxed text-foreground-600">
              高清静态漫画图源资源库，以画质为先、以收藏之心，让清晰的漫画内容触手可及。
            </p>
          </div>

          <div>
            <h4 className="text-sm font-medium text-foreground-950">浏览栏目</h4>
            <ul className="mt-4 space-y-2.5">
              {[
                { label: "画质精选", href: "#quality" },
                { label: "图源推荐", href: "#sources" },
                { label: "新作速递", href: "#new" },
                { label: "常见问题", href: "#faq" },
              ].map((l) => (
                <li key={l.href}>
                  <a
                    href={l.href}
                    className="text-sm whitespace-nowrap text-foreground-600 transition-colors hover:text-primary-600"
                  >
                    {l.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-medium text-foreground-950">关于我们</h4>
            <ul className="mt-4 space-y-2.5">
              {["品牌理念", "内容原则", "用户口碑", "联系方式"].map((t) => (
                <li key={t}>
                  <a
                    href="#about"
                    className="text-sm whitespace-nowrap text-foreground-600 transition-colors hover:text-primary-600"
                  >
                    {t}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-medium text-foreground-950">联系我们</h4>
            <ul className="mt-4 space-y-2.5 text-sm text-foreground-600">
              <li className="flex items-center gap-2">
                <i className="ri-mail-line"></i>
                contact@jmtiantang.example
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-time-line"></i>
                内容上新 · 全天候同步
              </li>
            </ul>
            <div className="mt-4 flex items-center gap-2">
              {["ri-wechat-line", "ri-weibo-line", "ri-bilibili-fill"].map(
                (icon) => (
                  <a
                    key={icon}
                    href="#home"
                    aria-label="社交媒体链接"
                    className="flex h-9 w-9 items-center justify-center rounded-full border border-background-300/70 text-foreground-600 transition-colors hover:border-primary-300 hover:text-primary-600"
                  >
                    <i className={icon}></i>
                  </a>
                ),
              )}
            </div>
          </div>
        </div>

        <div className="mt-10 flex flex-col items-center justify-between gap-3 border-t border-background-300/60 pt-6 sm:flex-row">
          <p className="text-xs text-foreground-500">
            © {new Date().getFullYear()} 静漫天堂漫画 · 高清静态图源资源库
          </p>
          <p className="text-xs text-foreground-500">
            尊重原作版权 · 仅作内容收藏与阅读分享
          </p>
        </div>
      </div>
    </footer>
  );
}